module.exports = __webpack_public_path__ + "img/basictavuktext.e7a40799.webp";